export default "__VITE_ASSET__HZAdf9rq__"